import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { theme } from 'antd';
import { RootState, AppDispatch } from 'store/configureStore';
import { reportingOp } from 'store/ducks/Reportings';
import { TitleList } from 'store/ducks/globalTypes';
import { set_selectedDate } from 'store/ducks/Reportings/reportingSlice';
import { useHierarchicalTreePage } from 'utils/hooks/useHierarchicalTreePage';
import { buildEntityToFunctionTree } from './EntityToFunctionTreeBuilder';
import HierarchicalTreePage from '../HierarchicalTreePage';
import { useTranslation } from 'react-i18next';

const EntityToFunctionTree: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const { date } = useSelector((state: RootState) => state.reportings);
  const { t } = useTranslation();

  const [selectedEntityId, setSelectedEntityId] = useState<number | null>(null);

  const { data, entityOptions } = useHierarchicalTreePage(
    reportingOp.filterEnityToFunctionChain,
    (res) => res?.data || [],
    selectedEntityId,
    date,
  );

  return (
    <HierarchicalTreePage
      title={t(TitleList.ENTITYTOFUNCTION)}
      data={data}
      entityOptions={entityOptions}
      selectedEntityId={selectedEntityId}
      setSelectedEntityId={setSelectedEntityId}
      onDateChange={(dateString) => {
        dispatch(set_selectedDate(dateString));
      }}
      buildTree={buildEntityToFunctionTree}
    />
  );
};

export default EntityToFunctionTree;
